if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector("form")
        this.form.querySelector("[name=id]").disabled = false
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        this.form.dataset.loading = ""
        const submitButton = this.querySelector('[type="submit"]')
        if (submitButton.classList.contains("loading")) return

        this.handleErrorMessage()

        submitButton.setAttribute("aria-disabled", true)

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]

        const formData = new FormData(this.form)
        formData.append("sections", "cart-drawer,header")
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description)
              return
            }

            // Dispatch event for cart drawer and overlay
            document.dispatchEvent(new CustomEvent('cart:add', {
              detail: { response, sections: response.sections }
            }))
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            submitButton.classList.remove("loading")
            submitButton.removeAttribute("aria-disabled")
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            )
          })
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message")

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}
